import { makeEditorClient } from "@op/api-client";
import { env } from "../utils/env";

export const editorClient = makeEditorClient(
  new URL("/api/editor", env.VITE_API_URL).toString()
);
